import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { API } from "../App";

function getVisitorId() {
  let vid = localStorage.getItem("t4y_vid");
  if (!vid) {
    vid = crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("t4y_vid", vid);
  }
  return vid;
}

function getSessionId() {
  let sid = sessionStorage.getItem("t4y_sid");
  if (!sid) {
    sid = crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem("t4y_sid", sid);
  }
  return sid;
}

export function usePageTracker(userType) {
  const location = useLocation();
  const lastTracked = useRef("");

  useEffect(() => {
    const key = location.pathname;
    if (key === lastTracked.current) return;
    if (key.startsWith("/nedhaavu")) return;
    lastTracked.current = key;

    const payload = {
      visitor_id: getVisitorId(),
      page: location.pathname,
      referrer: document.referrer || null,
      user_type: userType || "anonymous",
      session_id: getSessionId(),
    };

    fetch(`${API}/analytics/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }).catch(() => {});
  }, [location.pathname, userType]);
}
